import { SpotterEnvironment } from "@spotter/environments/environment.template";

export const environment: SpotterEnvironment = {
    siteName: 'SeagrassSpotter',
    tokenSource: 'seagrassspotter.org',
    //production: true,
    envName: 'staging',
    apiURL: "https://api.spotterstaging.com/v1",
    apiBaseUrl: "https://api.spotterstaging.com",
    //version: "5.1.9",
    enableAnalytics: false,
    matamoSiteID: '1',
    matamoSiteURL: ''
};
